import React, { forwardRef } from "react";
import MuiDialog, { type DialogProps } from "@material-ui/core/Dialog";
import Grow from "@material-ui/core/Grow";
import type { TransitionProps } from "@material-ui/core/transitions";

import { useFullscreenElement } from "src/utils/fullscreen";

export type { DialogProps };

const GrowTransition = forwardRef(function GrowTransition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Grow ref={ref} {...props} timeout={250} />;
});

/** This is just a wrapper of Mui's Dialog that patches `container` property to make
 * the dialog work in fullscreen mode.
 */
const Dialog = forwardRef((props: DialogProps, ref) => {
  const fullscreenElement = useFullscreenElement();

  return (
    <MuiDialog
      ref={ref}
      container={fullscreenElement || document?.body}
      TransitionComponent={GrowTransition}
      {...props}
    />
  );
});

export default Dialog;
